import { currentDateTime, decimalToTime } from "utils/formatter"
import { GridActionsCellItem } from "@mui/x-data-grid"
import { CallMissedOutgoing, RemoveRedEyeOutlined, Replay } from "@mui/icons-material"
import { CircularProgress } from "@mui/material"
import { AdminAssessmentsCrud } from "pages/Admin/TranscriptionSystem/AdminAssessments/hooks"
import { adminAssessmentsHooks } from "pages/Admin/TranscriptionSystem/AdminAssessments"

const useFields = () => {
    const { backToMarkingWordsLoading, openBackToTranscriptionConfirmation } = AdminAssessmentsCrud()

    const selectAndViewAssessment = adminAssessmentsHooks.useSelectAndTranscription()

    return [
        {
            field: 'update_date',
            headerName: "עדכון אחרון",
            width: 150,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (value) => `${currentDateTime(value.row?.update_date) || ""}`,
        },
        {
            field: 'marking_words_update_by_username',
            headerName: 'סומן ע"י',
            type: 'number',
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'transcription_duration',
            headerName: "משך תעתוק",
            type: 'string',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            valueGetter: ({ row }) => decimalToTime(row.transcription_duration),
        },
        {
            field: 'transcription_start_date',
            headerName: " התחלת תעתוק",
            width: 150,
            headerAlign: 'center',
            align: 'center',
            valueGetter: ({ row }) => `${currentDateTime(row?.transcription_start_date) || ""}`,
        },
        {
            field: 'transcription_end_date',
            headerName: " סיום תעתוק",
            width: 150,
            headerAlign: 'center',
            align: 'center',
            valueGetter: ({ row }) => `${currentDateTime(row?.transcription_end_date) || ""}`,
        },
        {
            field: 'enter_transcription',
            type: 'actions',
            headerName: "כניסה",
            width: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'actions',
            getActions: ({ row }) => {

                return [
                    <GridActionsCellItem
                        icon={<CallMissedOutgoing color='rating1' />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            selectAndViewAssessment(row)
                        }}
                        color="secondary"
                    />
                ];
            }
        },
        {
            field: 'view_marking_words',
            type: 'actions',
            headerName: "צפייה",
            width: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'actions',
            getActions: ({ row }) => {

                return [
                    <GridActionsCellItem
                        icon={<RemoveRedEyeOutlined color='rating1' />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            selectAndViewAssessment(row)
                        }}
                        color="secondary"
                    />
                ];
            }
        },
        {
            field: 'back_to_transcription',
            type: 'actions',
            headerName: "החזר לתעתוק",
            width: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerAlign: 'center',
            align: 'center',
            cellClassName: 'actions',
            getActions: ({ row }) => {

                const disabled = backToMarkingWordsLoading
                return [
                    <GridActionsCellItem
                        icon={<Replay color='yellow' />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => openBackToTranscriptionConfirmation(row, true)}
                        color="secondary"
                        disabled={disabled}
                    />
                ];
            }
        },
    ]
}

export default useFields 
